module.exports = __webpack_public_path__ + "img/icon-due-date.7a28bca8.svg";